import { isInternational } from '../../modules/global/_checkForInternational';
import { stripProhibitedCharactersOnSubmit } from '../../modules/global/_stripProhibitedCharactersOnSubmit';

var changeInputs = function (a, b, c) {
	var query = $(b).find(':selected').attr(c);
	$("input[name='" + a + "']").val(query);
	return false;
};

var dillardsEcomOrdersHide = function () {
	$('#dillards-orders-info-message, .dillards-com-orders-subject-select').hide();
};

var dillardsCardServiceTextHide = function () {
	$('#dillards-cardservices-info-message').hide();
};

var hideStoreStateCity = function () {
	$('.stores-state-select, .stores-city-select').hide();
};

var resetInputs = function () {
	$("input[name='contactSubject']").val('');
	$("input[name='storeLocation']").val('');
	$("select[name='storeCity']").val('');
	$("select[name='storeState']").val('');
	return false;
};

var scrollTop = function () {
	$('html, body').animate(
		{
			scrollTop: 0,
		},
		800
	);
};

var scrollTopForm = function () {
	$('html, body').animate(
		{
			scrollTop: $('#messages-form').offset().top - 110,
		},
		800
	);
};

var storesHide = function () {
	hideStoreStateCity();
	$('#stores-info-message, .stores-subject-select').hide();
};

var dillardsEcomOrdersChecked = function () {
	resetInputs();
	storesHide();
	$('#dillards-com-orders-subject-select').val(null);
	$('#dillards-orders-info-message').show();
	$('.dillards-com-orders-subject-select').show();
	if (isInternational()) $('.hide-when-international').hide();
};

var storesChecked = function () {
	resetInputs();
	$('#stores-info-message, .stores-subject-select').show();
	$('#stores-subject-select').val(null);
	$('#stores-state-select').val(null);
	$('#storeExperienceCities').val(null);
	$('.stores-city-select, #storeExperienceCities').attr('disabled', true).fadeTo(100, 0.7);
	hideStoreStateCity();
	dillardsEcomOrdersHide();
	dillardsCardServiceTextHide();
};

var beforeFormSubmit = function () {
	$('#contact-us-submit, #contact-us-reset').attr('disabled', true).fadeTo(100, 0.4);
};

var submitFail = function (html) {
	$('#contact-us-submit, #contact-us-reset').removeAttr('disabled').fadeTo(100, 1);
	$('#messages-form').html(
		'<div id="info-message" class="alert alert-danger alert-dismissible" role="alert">' +
			'<button class="alert-dismiss" type="button" data-dismiss="alert"><i class="fa fa-times"></i></button>' +
			'Error: Your message was not sent. Please try again. </div>'
	);
	scrollTopForm();
};

var documentSet = () => {
	if (isInternational()) {
		$('#groupNumber-2').prop('checked', true);
		dillardsEcomOrdersChecked();
		$('#dillards-com-orders-subject-select option[value="International Order Inquiry"]').prop('selected', true);
		$('contact-us-phone-label').parent().removeClass('required');
	} else {
		$('#groupNumber-1').prop('checked', true);
		storesChecked();
		var $stores = $('#groupNumber-1'),
			$dillardsEcomOrders = $('#groupNumber-2'),
			$dillardsCard = $('#groupNumber-3');
		$('input[name=groupOption]:radio').on('change', function (event) {
			if ($stores.prop('checked')) {
				storesChecked();
				dillardsCardServiceTextHide();
			}
			if ($dillardsEcomOrders.prop('checked')) {
				dillardsEcomOrdersChecked();
				dillardsCardServiceTextHide();
			}
			if ($dillardsCard.prop('checked')) {
				storesHide();
				dillardsEcomOrdersHide();
				resetInputs();
				$("input[name='contactSubject']").val("Contact Dillard's Card Services");
				$('#dillards-cardservices-info-message').show();
			}
		});
		$('#stores-subject-select').on('change', function () {
			var selectedValue = this.value,
				contactOrExperience = '';
			selectedValue == 'Contact a Store Location' || selectedValue == 'Tell Us About a Store Experience'
				? $('.stores-state-select, .stores-city-select').show()
				: hideStoreStateCity();
		});
	}

	//if form is reset
	if (location.href.indexOf('#reset') >= 0) {
		$('#messages-form').html(
			'<div id="info-message" class="alert alert-info alert-dismissible" role="alert">' +
				'<button class="alert-dismiss" type="button" data-dismiss="alert"><i class="fa fa-times"></i></button>' +
				'The form has been reset. </div>'
		);
		scrollTopForm();
	}
};

var dropdownChanges = () => {
	//listens for subject dropdown changes
	$('#stores-subject-select').change(function () {
		changeInputs('contactSubject', '#stores-subject-select', 'value');
	});
	//listens for location option drop down
	$('#storeExperienceCities').change(function () {
		changeInputs('storeLocation', '#storeExperienceCities', 'data-storenumber');
	});
	$('.dillards-com-orders-subject-select').change(function () {
		changeInputs('contactSubject', '#dillards-com-orders-subject-select', 'value');
	});
};

var submitForm = () => {
	var textInputs = $('#contact-us-form').find("input[type='text'], input[type='tel'], input[type='email'], textarea");
	textInputs.each(function () {
		$(this).val(stripProhibitedCharactersOnSubmit($(this).val()));
	});
	$.ajax({
		url: '/webapp/wcs/stores/servlet/ContactUs',
		dataType: 'html',
		type: 'POST',
		data: $('#contactUsForm').serialize(),
		beforeSend: beforeFormSubmit(),
		success: function (html) {
			var responseText = $(html).text(),
				failedResponse = responseText.indexOf('Your message has been sent') < 0 || responseText.length === 0;
			if (!failedResponse) {
				$('.send-us-a-message').empty();
				$('#messages-sent').html(
					'<div id="info-message" class="alert alert-success alert-dismissible" role="alert">' +
						'<button class="alert-dismiss" type="button" data-dismiss="alert"><i class="fa fa-times"></i></button>' +
						'Your message has been sent.  Thank You. </div>'
				);
				scrollTop();
			} else submitFail(html);
		},
		error: function (html) {
			submitFail(html);
		},
	});
};

export { documentSet, dropdownChanges, submitForm };
